export const HEADER_OFFSET = 129;
export const DEFAULT_SCROLL_DELAY = 100;
export const DEFAULT_MAX_SCROLL_ATTEMPTS = 50;
